import {
  Component,
  OnInit
} from '@angular/core';

import { AppState } from '../app.service';
// import { Title } from './title';
// import { XLargeDirective } from './x-large';
import { ActivatedRoute }    from '@angular/router';
import { Subscription } from 'rxjs/Subscription';

import { TweenMax, TimelineMax } from "gsap";
import * as $ from 'jquery/dist/jquery.min.js';
import { BrowserModule, Title }  from '@angular/platform-browser';


@Component({
  /**
   * The selector is what angular internally uses
   * for `document.querySelectorAll(selector)` in our index.html
   * where, in this case, selector is the string 'home'.
   */
  selector: 'experiences',  // <home></home>
  /**
   * We need to tell Angular's Dependency Injection which providers are in our app.
   */
  providers: [
    Title
  ],
  /**
   * Our list of styles in our component. We may add more to compose many styles together.
   */
  styles: [ require('./experiences.component.css') ],
  /**
   * Every Angular template is first compiled by the browser before Angular runs it's compiler.
   */
  template: require('./experiences.component.html')
})
export class ExperiencesComponent implements OnInit {
  /**
   * Set our default values
   */
  public localState = { value: '' };
  fees:any;
  sub: Subscription;
  part: string;
  tiger = "assets/images/TIGER_lb1.jpg";
  cap = "assets/images/CAP10_lb2.jpg";
  offset = 250;

  /**
   * TypeScript public modifiers
   */
  constructor(
    public appState: AppState,
    public title: Title,
    private activatedRoute: ActivatedRoute
  ) {}

  public ngOnInit() {
    // console.log('hello `experiences` component', this.activatedRoute.snapshot.data['part']);
    this.title.setTitle("The Tiger Club | Air Experiences");

    this.fees = this.appState.getFees();
     // console.log("this ", this.fees.tiger.normal);
    
    this.sub = this.activatedRoute
      .params
      .subscribe(params => {
        this.part = params['part'];
        if(this.part){
          // console.log("PART IS :", this.part);
          this.scrollTo(this.part);
        }
      });
     
  }

  scrollTo(id){

     $('html, body').animate({
        scrollTop: $("#"+id).offset().top - 40
    }, 10);
  }

  public submitState(value: string) {
    // console.log('submitState', value);
    this.appState.set('value', value);
    this.localState.value = '';
  }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/experiences/experiences.component.ts